import { createSlice } from '@reduxjs/toolkit';
import { findQuestionCategoryAPI, getQuestionCategoryByIdAPI } from '../../../service/quiz/quiz.category.service';

const initialState = {
  isLoading: false,
  error: null,
  totalElements: 0,
  totalPages: 0,
  numberOfElements: 0,
  qCategories: [],
  qCategory: null,
  search: {
    page: 0,
    size: 10,
    value: '',
    orders: [
      {
        order: 'asc',
        property: 'createdAt',
      },
    ],
  },
};

const slice = createSlice({
  name: 'qCategory',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
      state.error = null;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    setQuestionCategories(state, action) {
      state.isLoading = false;
      const response = action.payload;
      state.qCategories = response.data;
      state.totalElements = response.totalElements;
      state.totalPages = response.totalPages;
      state.numberOfElements = response.numberOfElements;
    },
    setQuestionCategory(state, action) {
      state.isLoading = false;
      const response = action.payload;
      state.qCategory = response.data;
    },
    setQuestionCategorySearch(state, action) {
      state.isLoading = false;
      state.search = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;
// Actions
export const { setQuestionCategorySearch } = slice.actions;
// ----------------------------------------------------------------------

export function getQuestionCategories() {
  return async (dispatch, getState) => {
    dispatch(slice.actions.startLoading());
    // read state from rootReducer
    const { qCategory } = getState();

    const resp = await findQuestionCategoryAPI({ ...qCategory.search, value: `%${qCategory.search.value}%` });

    if (resp.code === '200') dispatch(slice.actions.setQuestionCategories(resp));
    else dispatch(slice.actions.hasError(resp));
  };
}

export function getQuestionCategory(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    const resp = await getQuestionCategoryByIdAPI(id);
    if (resp.code === '200') dispatch(slice.actions.setQuestionCategory(resp));
    else dispatch(slice.actions.hasError(resp));
  };
}
